/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OfficeRoleDto } from '@gh/builder-shared-data';
import { getRouteInitData } from '@gh/common-shared';
import { assign } from 'lodash';

@Component({
  standalone: false,
  selector: 'gh-office-role-permissions-tab-container',
  templateUrl: 'office-role-permissions-tab-container.component.html',
})
export class OfficeRolePermissionsTabContainerComponent implements OnInit {
  officeRole: OfficeRoleDto;

  constructor(
    private route: ActivatedRoute,
  ) {

  }

  ngOnInit(): void {
    assign(this, getRouteInitData(this.route));
  }
}
